import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-template-keyquestions',
    standalone: false,
    templateUrl: './template-keyquestions.component.html',
    styleUrl: './template-keyquestions.component.scss'
})
export class TemplateKeyquestionsComponent {
    @Input({ required: true }) data: { key_question: string, answer: string, description: string, dirty: boolean }[] = [];
    @Input({ required: true }) state: boolean = false;

}
